import { useMsal } from '@azure/msal-react';
import { StatsigProvider } from '@statsig/react-bindings/src/StatsigProvider';
import { useClientAsyncInit } from '@statsig/react-bindings/src/useClientAsyncInit';
import { StatsigSessionReplayPlugin } from '@statsig/session-replay';
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics';
import React from 'react';
import PageLoader from '../../../components/pageLoader/pageLoader';

interface StatsigProviderWrapperProps {
  children: React.ReactNode;
}

const StatsigProviderWrapper = (props: StatsigProviderWrapperProps) => {
  const { children } = props;
  const { accounts } = useMsal();
  const { client } = useClientAsyncInit(
    'client-9JeqSsI95AbuyDKfSsr54bbVdqPFTMBir1GjCUii4jK',
    { userID: accounts[0]?.username || 'anonymous' },
    {
      plugins: [
        new StatsigAutoCapturePlugin(),
        new StatsigSessionReplayPlugin(),
      ],
    },
  );
  return (
    <StatsigProvider client={client} loadingComponent={<PageLoader />}>
      {children}
    </StatsigProvider>
  );
};

export default StatsigProviderWrapper;
